<template>
  <div>
    <!-- Bagian atas tetap sama -->
    <div class="table_scrol">
      <div class="w-card__content content-hardcode mb3">
        <div class="cards-table-grid">
          <div class="dashboard-grid">
            <div
              v-for="(card, index) in cards2"
              :key="index"
              class="card-box"
              @click="openDialog(index)"
            >
              <div class="card-content">
                <div class="card-text">
                  <h2 class="card-value">{{ formatNumber(card.jumlah) }}</h2>
                  <small 
                   class="card-subtitle" 
                   :class="[
                     'sub' + (index + 1), 
                     { 'with-highlight': !['Jumlah Servis ET Terima', 'Jumlah Servis ET Tolak'].includes(card.keterangan) }
                   ]"
                 >
                   {{ card.keterangan }}
              </small>
                </div>
                <div class="card-icon" :class="'bg' + (index + 1)">
                  <img src="/images/chart1.png" alt="chart" class="icon-img" />
                </div>
              </div>
            </div>
          </div>

          <div class="tables-stack">
            <!-- Table Temu Janji -->
            <div class="w-table-wrap modern-table" style="max-height: 400px;">
              <div class="table-profil-scrol">
                <table class="w-table w-100">
                  <thead>
                    <tr class="table-header">
                      <th colspan="3" class="text-center">
                        <div class="header-column">
                          <span class="title"> TEMU JANJI</span>
                          <span class="datetime">
                            📅 {{ currentDate }} | 🕒 {{ currentTime }}
                          </span>
                        </div>
                      </th>
                    </tr>
                    <tr class="table-subheader">
                      <th class="text-center">Tugas</th>
                      <th class="text-center">Tarikh Temu Janji</th>
                      <th class="text-center">Bilangan</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, index) in tarikh_aiman" :key="index">
                      <td class="text-center">{{ row.Tugas }}</td>
                      <td class="text-center">{{ row.Tarikh }}</td>
                      <td class="text-center">{{ row.Bilangan }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <!-- Table Tugasan -->
            <div class="w-table-wrap modern-table" style="max-height: 400px;">
              <div class="table-profil-scrol">
                <table class="w-table w-100">
                  <thead>
                    <tr class="table-header">
                      <th colspan="3" class="text-center">
                        <div class="header-column">
                          <span class="title"> TUGASAN</span>
                        </div>
                      </th>
                    </tr>
                    <tr class="table-subheader">
                      <th class="text-center">Tugas</th>
                      <th class="text-center">Tarikh Terima Tugas</th>
                      <th class="text-center">Bilangan</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, index) in tugasan" :key="index">
                      <td class="text-center">{{ row.Tugas }}</td>
                      <td class="text-center">{{ row.Tarikh }}</td>
                      <td class="text-center">
                        <button class="btn-modern" @click="item(row)">
                          {{ row.Bilangan }}
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <div class="trend-grid">
          <div class="trend-box trend-box-full">
            <w-select
                class="mt4" 
                v-model="carian_tahun.bulan_tahun" 
                :items="bulan_tahun"
                @input="getServis()" 
              />
            <GChart
              type="LineChart"
              :data="d_servis.datas"
              :options="{
                title: 'Jumlah Servis ET',
                curveType: 'function',
                legend: { position: 'bottom' },
                chartArea: {
                  left: 50, right: 20, top: 40, bottom: 60 
                },
                vAxis: {
                   viewWindow: {
                     min: 0
                   },
                   format: '0', 
                 },
                 series: {
                  0: { color: '#ef4444' } 
                },
                tooltip: { isHtml: true }
              }"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- Dialog 1 - Jumlah Servis PD -->
    <w-dialog 
    v-model="dialog3.show"
    :fullscreen="true"
    :width="isMobile ? '100%' : isTablet ? '90%' : '1200'"
    :persistent="dialog3.persistent"
    :persistent-no-animation="dialog3.persistentNoAnimation"
    title-class="primary-dark1--bg white"
    class="responsive-dialog"
  >
    <template #title>
      Jumlah Servis PD
    </template>

    <div class="chart-grid responsive-chart-grid">
      <div class="chart-box">
        <GChart 
          type="PieChart" 
          :data="chartTernakan" 
          :options="{ 
            title: 'Jenis Ternakan', 
            legend: { position: isMobile ? 'bottom' : 'right' },
            chartArea: { width: isMobile ? '90%' : '80%', height: isMobile ? '70%' : '75%' }
          }"/>
      </div>

      <div class="chart-box">
        <GChart 
          type="PieChart" 
          :data="chartBaka" 
          :options="{ 
            title: 'Baka', 
            legend: { position: isMobile ? 'bottom' : 'right' },
            chartArea: { width: isMobile ? '90%' : '80%', height: isMobile ? '70%' : '75%' }
          }"/>
      </div>

      <div class="chart-box">
         <GChart 
           type="ColumnChart" 
           :data="safeChartData(chartNegeri, ['Negeri', 'Jumlah'])"
           :options="{
             title: 'Negeri',
             legend: { position: 'none' },
             hAxis: { title: 'Negeri' }, 
             vAxis: { title: 'Jumlah', minValue: 0 },
             chartArea: { width: isMobile ? '75%' : '70%', height: isMobile ? '60%' : '70%' }
           }"/>
       </div>

       <div class="chart-box">
         <GChart 
           type="ColumnChart" 
           :data="safeChartData(chartDaerah, ['Daerah', 'Jumlah'])"
           :options="{
             title: 'Daerah',
             legend: { position: 'none' },
             hAxis: { title: 'Daerah' }, 
             vAxis: { title: 'Jumlah', minValue: 0 },
             chartArea: { width: isMobile ? '75%' : '70%', height: isMobile ? '60%' : '70%' }
           }"/>
       </div>
    </div>

    <template #actions>
      <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 10px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="dialog3.show = false">TUTUP</w-button>
    </template>
  </w-dialog>

  <!-- Dialog 2 - Jumlah Servis ET -->
  <w-dialog 
    v-model="dialog4.show"
    :fullscreen="true"
    :width="isMobile ? '100%' : isTablet ? '90%' : '1200'"
    :persistent="dialog4.persistent"
    :persistent-no-animation="dialog4.persistentNoAnimation"
    title-class="primary-dark1--bg white"
    class="responsive-dialog"
  >
    <template #title>
      Jumlah Servis ET
    </template>

    <div class="chart-grid responsive-chart-grid">
      <div class="chart-box">
        <GChart 
          type="PieChart" 
          :data="chartTernakan" 
          :options="{ 
            title: 'Jenis Ternakan', 
            legend: { position: isMobile ? 'bottom' : 'right' },
            chartArea: { width: isMobile ? '90%' : '80%', height: isMobile ? '70%' : '75%' }
          }"/>
      </div>

      <div class="chart-box">
        <GChart 
          type="PieChart" 
          :data="chartBaka" 
          :options="{ 
            title: 'Baka', 
            legend: { position: isMobile ? 'bottom' : 'right' },
            chartArea: { width: isMobile ? '90%' : '80%', height: isMobile ? '70%' : '75%' }
          }"/>
      </div>

      <div class="chart-box">
         <GChart 
           type="ColumnChart" 
           :data="safeChartData(chartNegeri, ['Negeri', 'Jumlah'])"
           :options="{
             title: 'Negeri',
             legend: { position: 'none' },
             hAxis: { title: 'Negeri' }, 
             vAxis: { title: 'Jumlah', minValue: 0 },
             chartArea: { width: isMobile ? '75%' : '70%', height: isMobile ? '60%' : '70%' }
           }"/>
       </div>

       <div class="chart-box">
         <GChart 
           type="ColumnChart" 
           :data="safeChartData(chartDaerah, ['Daerah', 'Jumlah'])"
           :options="{
             title: 'Daerah',
             legend: { position: 'none' },
             hAxis: { title: 'Daerah' }, 
             vAxis: { title: 'Jumlah', minValue: 0 },
             chartArea: { width: isMobile ? '75%' : '70%', height: isMobile ? '60%' : '70%' }
           }"/>
       </div>
    </div>
    
    <template #actions>
      <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 10px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="dialog4.show = false">TUTUP</w-button>
    </template>
  </w-dialog>
  </div>
</template>

<script>
import { GChart } from "vue-google-charts";
export default {
  props: {
    d_tahun: { type: [Array, Object], required: true },
    role_id : String
  },
  components: {
        GChart
    },
  data() {
    return {
      cards2: [],
      premis: [],
      lkp_ternakan: [],
      currentTime: "",
      currentDate: "",
      selectedTernakanId: null,
      lastItemData: null,
      chartServisEt: [["Tahun", "Jumlah"]],
      dialog3: {
        valid: false,
        show: false,
        fullscreen: false,
        persistent: true,
        persistentNoAnimation: false,
        loading: false,
        width: 1800,
        item: {}
      },
      dialog4: {
        valid: false,
        show: false,
        fullscreen: false,
        persistent: true,
        persistentNoAnimation: false,
        loading: false,
        width: 1800,
        item: {}
      },
      carian_tahun :{bulan_tahun: 1},
      d_servis: [],
      bulan_tahun:[
        {value: 2, label: "TAHUN"},
        {value: 1, label: "BULAN BAGI TAHUN SEMASA"},
      ],
      chartTernakan: [
          ['Umur Hari','Berat Kg','ADG'],
        ],
      chartBaka: [
          ['Umur Hari','Berat Kg'],
        ],
      chartJurusan: [
          ['Umur Hari','ADG'],
        ],
      carian: { tahun: "" },
      windowWidth: window.innerWidth,
    };
  },
  computed: {
    isMobile() {
      return this.windowWidth <= 768;
    },
    isTablet() {
      return this.windowWidth > 768 && this.windowWidth <= 1024;
    },
  },
  methods: {

  // getServis(){
  //        // this.carian_tahun.bulan_tahun = 1;
  //        this.$zcomm.get(this.api_service + 'dashboard/dashboard-serviset?ind='+this.carian_tahun.bulan_tahun, {}).then(res => {
  //              this.d_servis = res
  //           })
         
  //     },

      getServis(){
         // this.carian_tahun.bulan_tahun = 1;
         this.$zcomm.get(this.api_service + 'dashboard/dashboard-serviset?ind='+this.carian_tahun.bulan_tahun+'&role_id='+this.role_id, {}).then(res => {
               this.d_servis = res
            })
         
      },
      getTarikhaiman(){
      // this.carian_tahun.bulan_tahun = 1;
      this.$zcomm.get(this.api_service + 'dashboard/dashboard-tarikhaiman', {}).then(res => {
            this.tarikh_aiman = res
         })
      
       },
       getTugasan(){
      // this.carian_tahun.bulan_tahun = 1;
      this.$zcomm.get(this.api_service + 'dashboard/dashboard-tugasanaiman', {}).then(res => {
            this.tugasan = res
         })
      
   },

  async getPremis() {
      try {
        const res = await this.$zcomm.get(this.api_service + "lookup/premis", {});
        this.premis = res.data ?? res;
      } catch (e) {
        console.error("Gagal ambil premis:", e);
      }
    },

  async getData(item) {
  if (item === 1) {
    this.carian.tahun = new Date().getFullYear();
  }

  try {
    const res = await this.$zcomm.get(
      this.api_service +
        "dashboard/dashboard-etman?tahun=" + this.carian.tahun +
        "&premis_id=" + (this.carian.premis_id ?? ""),
      {}
    );

    const data = res.data ?? res;

    if (Array.isArray(data)) {
      this.cards2 = data;
      this.lkp_ternakan =
        data.find(d => d.keterangan === "Jumlah Ternakan")?.lkp_ternakan ?? [];

      this.chartServisEt = [["Bulan", "Jumlah"]];

      // --- Servis AI ---
      const servisEt = data.find(d => d.keterangan === "Jumlah Servis ET");
      if (servisEt && Array.isArray(servisEt.data)) {
        const grouped = {};
        servisEt.data.forEach(row => {
          const bulan = parseInt(row.bulan, 10);
          grouped[bulan] = (grouped[bulan] || 0) + 1;
        });

        Object.keys(grouped)
          .sort((a, b) => a - b)
          .forEach(b => {
            this.chartServisEt.push([this.formatBulan(b), grouped[b]]);
          });
      }

      
    } else {
      this.cards2 = [];
      this.chartServisEt = [["Bulan", "Jumlah"]];
    }
  } catch (err) {
    console.error("Gagal ambil data dashboard:", err);
    this.cards2 = [];
    this.chartServisEt = [["Bulan", "Jumlah"]];
  }
},

safeChartData(data, headers) {
    if (!data || data.length <= 1) {
      return [headers, ['Tiada Data', 0]]
    }

    
    const cleanData = data.map((row, i) => {
      if (i === 0) return row // header
      return [row[0], Number(row[1]) || 0]
    })
    return cleanData
  },

updateDateTime() {
  const now = new Date();

  
  this.currentDate = now.toLocaleDateString("ms-MY", {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric"
  });

  
  this.currentTime = now.toLocaleTimeString("en-US", { 
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true 
  });
},

formatNumber(value) {
    if (value === null || value === undefined) return '0';
    const num = parseInt(value);
    return num.toLocaleString('en-MY'); 
  },

formatBulan(val) {
    const bulan = [
      "Jan", "Feb", "Mar", "Apr", "Mei", "Jun",
      "Jul", "Agu", "Sep", "Okt", "Nov", "Des"
    ];

    if (!val) return val;

    // kalau numeric string "09" / "9"
    if (!isNaN(val)) {
      const idx = parseInt(val, 10) - 1;
      return bulan[idx] || val;
    }

    
    const lower = val.toLowerCase();
    const map = {
      januari: "Jan", februari: "Feb", maret: "Mar", april: "Apr",
      mei: "Mei", juni: "Jun", juli: "Jul", agustus: "Agu",
      september: "Sep", oktober: "Okt", november: "Nov", desember: "Des"
    };
    return map[lower] || val;
  },

  item(row) {

      if (row.Tugas === 'Perkhidmatan AI') {
        window.location.href =
          window.route('art.semakan.index') +
          '?lkp_art_id=1&lkp_status_id=31';
      }

      if (row.Tugas === 'Perkhidmatan PD') {
        window.location.href =
          window.route('art.semakan.index') +
          '?lkp_art_id=2&lkp_status_id=31';
      }

      if (row.Tugas === 'Perkhidmatan ET') {
        window.location.href =
          window.route('art.semakan.index') +
          '?lkp_art_id=3&lkp_status_id=31';
      }

   },

  
  openDialog(index) {
  const card = this.cards2[index]; 
  this.lastItemData = card; 

  // kalau card punya lkp_ternakan, isi dropdown
  this.lkp_ternakan = card.lkp_ternakan || [];
  this.selectedTernakanId = 0; 

  if (index === 0) {
    this.ChartPd(card); 
    this.dialog3.show = true; 
  } else if (index === 1) {
    this.ChartEt(card);         
    this.dialog4.show = true; 
  } 
},


  ChartPd(item) {
     const list = item.data ?? [];
     console.log('Data for ChartPd:', list); // Debug

     this.chartBaka = [['Baka', 'Jumlah']];
     this.chartNegeri = [['Negeri', 'Jumlah']];
     this.chartTernakan = [['Jenis', 'Jumlah']];
     this.chartDaerah = [['Daerah', 'Jumlah']];
     this.filteredChartDaerah = [['Daerah', 'Jumlah']];

     const bakaMap = {};
     const negeriMap = {};
     const ternakanMap = {};
     const daerahMap = {};
     
     // Simpan data asli untuk filtering
     this.originalDaerahData = [];

     list.forEach(row => {
       const bakaNama = row.lkp_baka?.nama ?? 'Tidak Diketahui';
       bakaMap[bakaNama] = (bakaMap[bakaNama] || 0) + 1;

       const negeriNama = row.lkp_negeri?.nama ?? 'Tidak Diketahui';
       negeriMap[negeriNama] = (negeriMap[negeriNama] || 0) + 1;

       const ternakanNama = row.lkp_ternakan?.nama ?? 'Tidak Diketahui';
       ternakanMap[ternakanNama] = (ternakanMap[ternakanNama] || 0) + 1;

       const daerahNama = row.lkp_daerah?.nama ?? 'Tidak Diketahui';
       const negeriId = row.lkp_negeri?.id;
       
       daerahMap[daerahNama] = (daerahMap[daerahNama] || 0) + 1;
       
       // Simpan data asli untuk filtering
       this.originalDaerahData.push({
         daerah: daerahNama,
         negeri: negeriNama,
         negeriId: negeriId,
         count: 1
       });
     });

     // Pastikan data chart negeri valid
     Object.entries(negeriMap).forEach(([nama, jumlah]) => {
       if (nama && jumlah > 0) {
         this.chartNegeri.push([nama, jumlah]);
       }
     });

     Object.entries(bakaMap).forEach(([nama, jumlah]) => this.chartBaka.push([`${nama} (${jumlah})`, jumlah]));
     Object.entries(ternakanMap).forEach(([nama, jumlah]) => this.chartTernakan.push([`${nama} (${jumlah})`, jumlah]));
     Object.entries(daerahMap).forEach(([nama, jumlah]) => {
       this.chartDaerah.push([nama, jumlah]);
       this.filteredChartDaerah.push([nama, jumlah]);
     });
     
     // Simpan data asli chartDaerah
     this.originalChartDaerah = [...this.chartDaerah];
     this.selectedNegeri = null;
     
     console.log('Chart Negeri data:', this.chartNegeri); // Debug
     console.log('Chart Daerah data:', this.chartDaerah); // Debug
   },

 


  ChartEt(item) {
     const list = item.data ?? [];
     console.log('Data for ChartEt:', list); // Debug

     this.chartBaka = [['Baka', 'Jumlah']];
     this.chartNegeri = [['Negeri', 'Jumlah']];
     this.chartTernakan = [['Jenis', 'Jumlah']];
     this.chartDaerah = [['Daerah', 'Jumlah']];
     this.filteredChartDaerah = [['Daerah', 'Jumlah']];

     const bakaMap = {};
     const negeriMap = {};
     const ternakanMap = {};
     const daerahMap = {};
     
     // Simpan data asli untuk filtering
     this.originalDaerahData = [];

     list.forEach(row => {
       const bakaNama = row.lkp_baka?.nama ?? 'Tidak Diketahui';
       bakaMap[bakaNama] = (bakaMap[bakaNama] || 0) + 1;

       const negeriNama = row.lkp_negeri?.nama ?? 'Tidak Diketahui';
       negeriMap[negeriNama] = (negeriMap[negeriNama] || 0) + 1;

       const ternakanNama = row.lkp_ternakan?.nama ?? 'Tidak Diketahui';
       ternakanMap[ternakanNama] = (ternakanMap[ternakanNama] || 0) + 1;

       const daerahNama = row.lkp_daerah?.nama ?? 'Tidak Diketahui';
       const negeriId = row.lkp_negeri?.id;
       
       daerahMap[daerahNama] = (daerahMap[daerahNama] || 0) + 1;
       
       // Simpan data asli untuk filtering
       this.originalDaerahData.push({
         daerah: daerahNama,
         negeri: negeriNama,
         negeriId: negeriId,
         count: 1
       });
     });

     // Pastikan data chart negeri valid
     Object.entries(negeriMap).forEach(([nama, jumlah]) => {
       if (nama && jumlah > 0) {
         this.chartNegeri.push([nama, jumlah]);
       }
     });


     Object.entries(bakaMap).forEach(([nama, jumlah]) => this.chartBaka.push([`${nama} (${jumlah})`, jumlah]));
     Object.entries(ternakanMap).forEach(([nama, jumlah]) => this.chartTernakan.push([`${nama} (${jumlah})`, jumlah]));
     Object.entries(daerahMap).forEach(([nama, jumlah]) => {
       this.chartDaerah.push([nama, jumlah]);
       this.filteredChartDaerah.push([nama, jumlah]);
     });
     
     // Simpan data asli chartDaerah
     this.originalChartDaerah = [...this.chartDaerah];
     this.selectedNegeri = null;
     
     console.log('Chart Negeri data:', this.chartNegeri); // Debug
     console.log('Chart Daerah data:', this.chartDaerah); // Debug
   },
  
  handleResize() {
    this.windowWidth = window.innerWidth;
  }
},

  mounted() {
    this.getData(1);
    this.getPremis();
    this.getServis();
    this.getTarikhaiman();
    this.getTugasan();
    this.updateDateTime();
    setInterval(this.updateDateTime, 1000);
    window.addEventListener('resize', this.handleResize);
    this.handleResize(); // Call once to set initial value
  },
  
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  }
};
</script>

<style scoped>
/* ===== DASHBOARD LAYOUT ===== */
.cards-table-grid {
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 24px;
  margin-top: 24px;
  align-items: start;
}

.dashboard-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 16px;
  margin-top: 20px;
}

.tables-stack {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.trend-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 20px;
  margin-top: 30px;
}

/* ===== CARD STYLES ===== */
.card-box {
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  border-radius: 16px;
  padding: 24px 20px;
  box-shadow: 
    0 4px 6px -1px rgba(0, 0, 0, 0.1),
    0 2px 4px -1px rgba(0, 0, 0, 0.06);
  transition: all 0.3s ease;
  cursor: pointer;
  border: 1px solid #e2e8f0;
  position: relative;
  overflow: hidden;
  min-height: 120px;
  display: flex;
  align-items: center;
}

.card-box:hover {
  transform: translateY(-4px);
  box-shadow: 
    0 20px 25px -5px rgba(0, 0, 0, 0.1),
    0 10px 10px -5px rgba(0, 0, 0, 0.04);
  border-color: #cbd5e0;
}

.card-box::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, var(--card-color, #3b82f6), transparent);
}

.card-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 16px;
}

.card-text {
  flex: 1;
  min-width: 0;
}

.card-value {
  font-size: 32px;
  font-weight: 800;
  margin: 0 0 6px 0;
  color: #1a202c;
  line-height: 1;
  letter-spacing: -0.025em;
}

.card-subtitle {
  font-size: 14px;
  color: #64748b;
  display: block;
  font-weight: 500;
  line-height: 1.4;
  margin: 0;
}

.card-subtitle.with-highlight {
  position: relative;
  padding-bottom: 8px;
}

.card-subtitle.with-highlight::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  height: 3px;
  width: 40px;
  border-radius: 2px;
  background: var(--card-color, #3b82f6);
  transition: width 0.3s ease;
}

.card-box:hover .card-subtitle.with-highlight::after {
  width: 60px;
}

.card-icon {
  width: 56px;
  height: 56px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  background: var(--card-color, #3b82f6);
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.card-box:hover .card-icon {
  transform: scale(1.05);
  box-shadow: 0 8px 15px -3px rgba(0, 0, 0, 0.2);
}

.card-icon .icon-img {
  width: 26px;
  height: 26px;
  object-fit: contain;
  filter: brightness(0) invert(1);
}

/* Card Colors */
.card-box:nth-child(1) { --card-color: #3b82f6; }
.card-box:nth-child(2) { --card-color: #10b981; }
.card-box:nth-child(3) { --card-color: #f59e0b; }
.card-box:nth-child(4) { --card-color: #ef4444; }
.card-box:nth-child(5) { --card-color: #8b5cf6; }
.card-box:nth-child(6) { --card-color: #ec4899; }
.card-box:nth-child(7) { --card-color: #06b6d4; }
.card-box:nth-child(8) { --card-color: #84cc16; }
.card-box:nth-child(9) { --card-color: #f97316; }
.card-box:nth-child(10) { --card-color: #64748b; }

/* ===== CHART STYLES ===== */
.chart-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  margin-top: 16px;
  max-height: 70vh;
  overflow-y: auto;
  padding-right: 8px;
}

.chart-grid::-webkit-scrollbar {
  width: 6px;
}

.chart-grid::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

.chart-grid::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 10px;
}

.chart-grid::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.chart-box {
  background: #fff;
  border-radius: 12px;
  padding: 16px;
  box-shadow: 0px 2px 6px rgba(0,0,0,0.1);
  text-align: center;
  min-height: 280px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  border: 1px solid #e2e8f0;
}

.chart-box-full {
  grid-column: 1 / -1;
  background: #fff;
  border-radius: 12px;
  padding: 16px;
  box-shadow: 0px 2px 6px rgba(0,0,0,0.1);
  text-align: center;
  min-height: 320px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  border: 1px solid #e2e8f0;
}

.trend-box {
  background: #fff;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0px 2px 6px rgba(0,0,0,0.1);
  border: 1px solid #e2e8f0;
}

/* ===== TABLE STYLES ===== */
.modern-table table {
  width: 100%;
  border-collapse: collapse;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  color: #333;
  box-shadow: 0 2px 6px rgba(0,0,0,0.08);
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #e2e8f0;
}

.table-header {
  background: linear-gradient(90deg, #3b82f6, #2563eb) !important;
  color: white !important;
}

.table-header th {
  background: linear-gradient(90deg, #3b82f6, #2563eb) !important;
  color: white !important;
  padding: 14px 16px !important;
  border: none !important;
}

.header-column {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  text-align: center;
}

.header-column .title {
  font-size: 16px;
  font-weight: 600;
}

.header-column .datetime {
  font-size: 13px;
  font-weight: 400;
  opacity: 0.9;
}

.table-subheader {
  background: #f8fafc;
  font-weight: 500;
  color: #475569;
}

.table-subheader th {
  padding: 12px;
  border-bottom: 1px solid #e2e8f0;
}

tbody td {
  padding: 12px;
  border-bottom: 1px solid #f1f5f9;
}

tbody tr:hover {
  background: #f8fafc;
}

/* User table styling */
.table-container {
  max-height: 400px;
  overflow-y: auto;
  margin-top: 10px;
}

.user-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  overflow: hidden;
}

.user-table th,
.user-table td {
  padding: 12px;
  text-align: left;
  border-bottom: 1px solid #e2e8f0;
}

.user-table th {
  background-color: #f8fafc;
  font-weight: 600;
  color: #374151;
}

.user-table tr:hover {
  background-color: #f8fafc;
}

.role-badge {
  display: inline-block;
  background: #3b82f6;
  color: white;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 12px;
  margin: 2px;
  font-weight: 500;
}

/* ===== BUTTON STYLES ===== */
.btn-modern {
  background: linear-gradient(135deg, #4f46e5, #3b82f6);
  color: white;
  border: none;
  border-radius: 9999px;
  padding: 8px 18px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.25s ease;
  box-shadow: 0 2px 6px rgba(0,0,0,0.15);
  font-size: 13px;
}

.btn-modern:hover {
  background: linear-gradient(135deg, #4338ca, #2563eb);
  transform: scale(1.05);
  box-shadow: 0 4px 12px rgba(0,0,0,0.2);
}

.btn-modern:active {
  transform: scale(0.95);
}

.reset-btn {
  font-size: 11px !important;
  padding: 4px 10px !important;
}

/* ===== DIALOG STYLES ===== */
.dialog-content-custom {
  padding: 20px !important;
  max-height: 85vh !important;
  overflow-y: auto !important;
}

.selected-negeri {
  font-size: 14px;
  opacity: 0.8;
  font-weight: normal;
  margin-left: 8px;
}

.chart-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  padding: 0 8px;
}

/* ===== CHART LEGEND STYLES ===== */
.chart-umur-legend {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-bottom: 12px;
  padding: 8px;
}

.legend-dot-item {
  display: flex;
  align-items: center;
  gap: 6px;
}

.dot {
  font-size: 16px;
}

.female-dot {
  color: #3b82f6;
}

.male-dot {
  color: #ef4444;
}

.legend-label {
  font-size: 14px;
  color: #374151;
  font-weight: 500;
}

.selectable-chart {
  cursor: pointer;
}

.selectable-chart:hover {
  opacity: 0.9;
}

/* ===== RESPONSIVE DESIGN ===== */
@media (max-width: 1024px) {
  .cards-table-grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }
  
  .dashboard-grid {
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 14px;
  }
  
  .card-box {
    padding: 20px 16px;
    min-height: 110px;
  }
  
  .card-value {
    font-size: 28px;
  }
  
  .card-icon {
    width: 50px;
    height: 50px;
  }
  
  .card-icon .icon-img {
    width: 24px;
    height: 24px;
  }
  
  .chart-box {
    min-height: 260px;
  }
  
  .chart-box-full {
    min-height: 300px;
  }
}

@media (max-width: 768px) {
  .dashboard-grid {
    grid-template-columns: 1fr;
    gap: 12px;
  }
  
  .trend-grid {
    grid-template-columns: 1fr;
  }
  
  .chart-grid {
    grid-template-columns: 1fr;
    gap: 12px;
  }
  
  .chart-grid-mobile .chart-box {
    min-height: 240px;
  }
  
  .chart-grid-mobile .chart-box-full {
    min-height: 280px;
  }
  
  .card-box {
    padding: 18px 14px;
    min-height: 100px;
  }
  
  .card-value {
    font-size: 26px;
  }
  
  .card-subtitle {
    font-size: 13px;
  }
  
  .card-icon {
    width: 44px;
    height: 44px;
  }
  
  .card-icon .icon-img {
    width: 22px;
    height: 22px;
  }
  
  .chart-umur-legend {
    gap: 15px;
  }
  
  .legend-dot-item {
    gap: 4px;
  }
  
  .dot {
    font-size: 14px;
  }
  
  .legend-label {
    font-size: 13px;
  }
}

@media (max-width: 480px) {
  .card-content {
    gap: 12px;
  }
  
  .card-box {
    padding: 16px 12px;
    min-height: 90px;
  }
  
  .card-value {
    font-size: 24px;
  }
  
  .card-icon {
    width: 40px;
    height: 40px;
  }
  
  .card-icon .icon-img {
    width: 20px;
    height: 20px;
  }
  
  .trend-grid {
    gap: 16px;
    margin-top: 24px;
  }
  
  .trend-box {
    padding: 16px;
  }
}

/* Tablet landscape adjustments */
@media screen and (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
  .table_scrol {
    max-height: 85vh;
    overflow-y: auto;
  }
  
  .card-box {
    padding: 16px 12px;
    min-height: 90px;
  }
  
  .card-value {
    font-size: 26px;
  }
  
  .chart-box {
    padding: 12px;
    min-height: 220px;
  }
  
  .chart-box-full {
    padding: 12px;
    min-height: 260px;
  }
  
  .trend-box {
    padding: 16px;
    min-height: 240px;
  }
}

/* Animation for card appearance */
@keyframes cardAppear {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.card-box {
  animation: cardAppear 0.5s ease-out forwards;
}

/* Stagger animation for multiple cards */
.card-box:nth-child(1) { animation-delay: 0.1s; }
.card-box:nth-child(2) { animation-delay: 0.2s; }
.card-box:nth-child(3) { animation-delay: 0.3s; }
.card-box:nth-child(4) { animation-delay: 0.4s; }
.card-box:nth-child(5) { animation-delay: 0.5s; }
.card-box:nth-child(6) { animation-delay: 0.6s; }
.card-box:nth-child(7) { animation-delay: 0.7s; }
.card-box:nth-child(8) { animation-delay: 0.8s; }
.card-box:nth-child(9) { animation-delay: 0.9s; }
.card-box:nth-child(10) { animation-delay: 1s; }
</style>